import { Link } from "react-router-dom";
import "./Section.css";

function Section({ id, headingText, viewAllLink, children }) {
  return (
    <section id={id || headingText} className="section">
      <div className="section__header">
        <div className="section__title-row">
          {viewAllLink && <span className="section__spacer" />}
          <h2 className="section__heading">{headingText}</h2>
          {viewAllLink && (
            <Link to={viewAllLink} className="section__view-all">
              View All →
            </Link>
          )}
        </div>
        <hr className="section__divider" />
      </div>
      <div className="section__content">{children}</div>
    </section>
  );
}

export default Section;
